<template>
  <div class="scrollTitle">
    <div @mouseenter="stopAnim" @mouseleave="revertAnim" class="wrapper">
      <ul :style="getTransform" class="titlelist">
        <li @click.stop="clickItem(item)" v-for="item in scrollList">
          <div><i class="iconfont" :class="getIconClassNameBySort"></i>{{item.column1}}</div>
          <div class="time">{{item.column2}}</div>
          <div class="desc">{{item.column3}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: "generalScrollList",
    data() {
      return {
        currentShowIdx: 0,
        timer: null
      }
    },
    props: {

      /***
       * cousrseList:传入的主数据[Array]
       * during:滚动时间间隔[Number]
       */
      sort: {
        type: Number,
      },
      scrollList: {
        type: Array,
        default() {
          return [
            {
              "jsh": "69教室123",
              "kcm": "医院网络技术与管理",
              "llsynr": "计算机网络的基本概念",
              "skbj": "生1601",
              "skjc": "3",
              "skrq": "2019-03-04",
              "xs": "2"
            },
            {
              "jsh": "计算机1",
              "kcm": "毛概123",
              "llsynr": "计算机网络协议与体系架构",
              "skbj": "生16021",
              "skjc": "5",
              "skrq": "2019-03-04",
              "xs": "2"
            },
            {
              "jsh": "计算机2",
              "kcm": "大学英语1234",
              "llsynr": "局域网组建",
              "skbj": "生16021",
              "skjc": "7",
              "skrq": "2019-03-04",
              "xs": "1"
            },
            {
              "jsh": "69教室",
              "kcm": "医院网络技术与管理",
              "llsynr": "计算机网络的基本概念",
              "skbj": "生1601",
              "skjc": "1",
              "skrq": "2019-03-04",
              "xs": "2"
            }
          ];
        }
      },
      during: {
        type: Number,
        default: 3000,
      }
    },
    methods: {

      createAnim() {
        this.timer = setInterval(() => {
          if (this.currentShowIdx >= this.scrollList.length - 1) {
            this.currentShowIdx = 0;
            return;
          }
          this.currentShowIdx++;
        }, this.during)
      },
      clearAnim() {
        clearInterval(this.timer)
      },
      stopAnim() {
        this.clearAnim();
      },
      revertAnim() {
        this.createAnim()
      },
      clickItem(item) {
        this.$emit("clickItem", {item, type: this.sort})
      }

    },
    watch: {
      scrollList(newVal) {
        this.currentShowIdx = 0
      }
    },
    computed: {
      getTransform() {
        return `transform:translateY(${-this.currentShowIdx * 30}px)`
      },
      getIconClassNameBySort(){
        switch (this.sort) {
          case 0:
            return 'icon-app'
          case 1:
            return 'icon-ke'
          case 2:
            return 'icon-hui'
          case 3:
            return 'icon-shi'
          case 4:
            return 'icon-yuyue'
          case 5:
            return 'icon-yuyue1'
          case 6:
            return 'icon-ht_class'
          default:
            console.log('sort参数异常：'+this.sort)
        }
      }
    },
    mounted() {
      this.createAnim()
    },
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .scrollTitle
    /*margin-top 10px*/
    /*margin-top 10px*/
    margin-bottom -5px

    .wrapper
      height 30px
      overflow hidden

      .titlelist
        transition 300ms

        li
          padding 0 10px
          overflow hidden
          line-height 30px
          height 30px
          transition 300ms
          cursor pointer
          white-space nowrap
          width 95%
          margin auto
          font-size 0

          &:hover div
            color #666666

          div:first-of-type
            width 120px
            text-align left
            padding-right 0
            padding-left 2px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
          div.time
            width 90px
            text-align center
          div.desc
            width auto
          div
            display inline-block
            padding 0 10px
            max-width 200px
            width 114px
            /*max-width 80px*/
            /*min-width 70px*/
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
            text-align left
            font-size 14px
            color #999999
            line-height 30px
            height 30px
            flex 1
            transition 300ms

            i.iconfont
              color #2b5c95
              font-size 14px
              margin-right 5px
              vertical-align middle

</style>


// WEBPACK FOOTER //
// src/components/schedule/generalScrollList.vue